import { render, staticRenderFns } from "./address-select.vue?vue&type=template&id=0513a351&scoped=true"
import script from "./address-select.vue?vue&type=script&setup=true&lang=js"
export * from "./address-select.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513a351",
  null
  
)

export default component.exports